import React from "react";
import Layout from "./Layout";
import { Helmet } from "react-helmet";

function Contact() {
  return (
    <Layout customClass="content-area">
      <Helmet>
        <title>Contact - Instant QR Codes</title>
        <met
          name="description"
          content="Contact InstantQRCodes for any queries regarding our tool and it's operations."
        />
        <link rel="canonical" href="https://instantqrcodes.com/contact/" />
      </Helmet>
      <h3>Contact</h3>
      <p>
        Have any issues or concerns that you want to let us know. Please mail us
        directly at contact@instantqrcodes.com
      </p>
    </Layout>
  );
}

export default Contact;
